import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade"; // Import the fade effect
import "swiper/css/autoplay"; // Import autoplay module
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import slider1 from "../../assets/img/slider1.webp";
import slider2 from "../../assets/img/slider2.webp";
import slider3 from "../../assets/img/slider3.webp";
import "./slider.css";

const Slider = () => {
  const slides = [
    {
      id: 1,
      image: slider3,
      title: "Learn digital skills that shape futures",
      text: "Build practical confidence in coding, design, and digital marketing through hands-on training that prepares you for school, work, and entrepreneurship.",
      link: "/courses",
    },
    {
      id: 2,
      image: slider1,
      title: "Train for the future of work",
      text: "Our programs help learners gain the fundamentals, creativity, and real-world mindset needed to thrive in today’s digital economy.",
      link: "/signup",
    },
    {
      id: 3,
      image: slider2,
      title: "Supportive learning, real growth",
      text: "Join a community of mentors, peers, and opportunities designed to help you learn faster, build better projects, and pursue your next big step.",
      link: "/why-choose-us",
    },
  ];

  return (
    <section className="hero-section my-0">
      <Swiper
        modules={[Pagination, Autoplay, EffectFade]} // Using EffectFade instead of EffectCube
        effect="fade" // Fade effect for smoother transitions
        fadeEffect={{
          crossFade: true, // Crossfade effect between slides
        }}
        pagination={{ clickable: true, type: "bullets" }} // Bullet pagination
        autoplay={{ delay: 5000, disableOnInteraction: false }} // Auto slide every 5 seconds
        loop={true} // Looping slider
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id}>
            <div className="carousel-slide">
              <motion.img
                src={slide.image}
                alt={slide.title}
                className="parallax-image"
                data-swiper-parallax="-50%"
                initial={{ scale: 1.1 }}
                animate={{ scale: 1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
              />
              <div className="carousel-content">
                <span className="hero-kicker">TIMBAKTU ACADEMY</span>
                <motion.h2
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.8,
                    ease: "easeOut",
                    delay: index === 0 ? 0.3 : 0.5, // Stagger delay on first slide
                  }}
                >
                  {slide.title}
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.5 }}
                >
                  {slide.text}
                </motion.p>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.7 }}
                >
                  <Link to={slide.link} className="theme-btn">
                    Register Now
                  </Link>
                </motion.div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Slider;
